import { render, staticRenderFns } from "./RemainsListTable.vue?vue&type=template&id=14c2567a&scoped=true&"
import script from "./RemainsListTable.vue?vue&type=script&lang=js&"
export * from "./RemainsListTable.vue?vue&type=script&lang=js&"
import style0 from "./RemainsListTable.vue?vue&type=style&index=0&id=14c2567a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c2567a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/driehle1/rezeptdatenbank/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14c2567a')) {
      api.createRecord('14c2567a', component.options)
    } else {
      api.reload('14c2567a', component.options)
    }
    module.hot.accept("./RemainsListTable.vue?vue&type=template&id=14c2567a&scoped=true&", function () {
      api.rerender('14c2567a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/trip-remains-list/RemainsListTable.vue"
export default component.exports